import { useAuth } from "src/providers/AuthProvider";
import type { PermissionCheck } from "src/types/auth";

const hasPermission = (userPermissions: string[], permission: string) => userPermissions.includes(permission);

/** `string[]` means AND; `string[][]` means OR-of-ANDs. Distinguished by the first element. */
const isAndCheck = (check: string[] | string[][]): check is string[] => typeof check[0] === "string";

export const checkPermission = (permissionToCheck: PermissionCheck, userPermissions: string[]): boolean => {
	if (!permissionToCheck) return true;

	if (typeof permissionToCheck === "string") return hasPermission(userPermissions, permissionToCheck);

	if (isAndCheck(permissionToCheck)) return permissionToCheck.every((permission) => hasPermission(userPermissions, permission));

	return permissionToCheck.some((group) => group.every((permission) => hasPermission(userPermissions, permission)));
};

const useHasPermissions = (permissionToCheck: PermissionCheck) => {
	const { user } = useAuth();

	return checkPermission(permissionToCheck, user?.permissions ?? []);
};

export default useHasPermissions;
